/**
 * useChatQuickPrompts — quick questions loading
 */

import { useState, useEffect } from 'react';
import { shouldUseMock } from '../../../api/config';
import { chatApi, type QuickPrompt } from '../../../features/chat/api';

export function useChatQuickPrompts(sessionId: string | null) {
  const useMock = shouldUseMock('chat');
  const [quickPrompts, setQuickPrompts] = useState<QuickPrompt[]>([]);

  useEffect(() => {
    if (useMock) {
      setQuickPrompts([]);
      return;
    }

    let isCancelled = false;
    chatApi.getQuickPrompts(sessionId || undefined)
      .then(data => {
        if (!isCancelled) setQuickPrompts(data.slice(0, 4));
      })
      .catch(() => { /* silent */ });
    return () => { isCancelled = true; };
  }, [sessionId, useMock]);

  return { quickPrompts };
}
